import { View } from "binder"
import { FormBuilderElement } from "../../element";
import { ComponentSelectDecoratorViewModel } from "./componentSelectDecorator-viewModel"

export class ComponentSelectDecoratorView extends View<ComponentSelectDecoratorViewModel>{
    GetViewUniqueId(): string {
        return "V-2165E794-3AE2-4263-8E40-6A35AF0DFDDF"
    }
    loadHtml(): string {
        let element = require('./componentSelectDecorator.html').default;
        let style = require('./componentSelectDecorator.less');
        return element;
    }
    constructor() {
       super();
    }
    public set decoratorComponent(v: FormBuilderElement) { this._decoratorComponent = v; } public get decoratorComponent(): FormBuilderElement { return this._decoratorComponent;} private _decoratorComponent: FormBuilderElement;
    public set IsElementSelected(v: boolean) { this._IsElementSelected = v; } public get IsElementSelected(): boolean { return this._IsElementSelected;} private _IsElementSelected: boolean;

    decoratorClicked(e:Event){
        e.stopPropagation();
        this.dataContext.decoratorClicked();
    }
}
